import axios from 'axios'
import { FiltresListeProceduresPostModel, FiltresListeProceduresResponseModel } from '../types/filtresListeProceduresModel'
import HttpStatusCode from '../../../enum/httpStatusCode'
import liens from '../../../enum/liens'

export const getListeProcedure = (data: FiltresListeProceduresPostModel): Promise<FiltresListeProceduresResponseModel> => axios.post(liens.listeProcedureApi, data)
	.then((response) => response.data)

export const deleteProcedure = (procedureId: string): Promise<HttpStatusCode> => axios.delete(`/api/procedure/supprimer?procedureId=${procedureId}`)
	.then((response) => response.status)
